import React from 'react';
import { observer } from 'mobx-react-lite';
import { FiltersObject, PaginationDelegate } from 'store/general/paginationDelegate';
import {
  SubscribersSortBy,
  SubscribersSortOrder,
  SubscriberProgress,
  SubscriberIMQProgress,
} from 'types/electionService';
import { FilterDropdown } from 'components/common/general/CollectionManagementPanel/FilterDropdown';

const STATUS_FILTER_TITLES = {
  [SubscriberProgress.NOT_YET_STARTED]: 'Not Yet Started',
  [SubscriberProgress.IN_PROGRESS]: 'In Progress',
  [SubscriberProgress.COMPLETED]: 'Completed',
};

interface InitiateAddEmployeesFilters extends FiltersObject {
  subProgress: SubscriberIMQProgress | null;
}

interface Props {
  paginationDelegate: PaginationDelegate<SubscribersSortBy, SubscribersSortOrder, InitiateAddEmployeesFilters>;
}

export const SubProgressFilterDropdown: React.FC<Props> = observer(({ paginationDelegate }) => {
  if (!!paginationDelegate.filters.subProgress && !STATUS_FILTER_TITLES[paginationDelegate.filters.subProgress]) {
    throw new Error(`Unsupported filter value assigned! ${paginationDelegate.filters.subProgress}`);
  }
  return (
    <FilterDropdown
      filterName="Progress"
      $minWidth="30rem"
      optionsWidth="30rem"
      selectedFilterLabel={
        paginationDelegate.filters.subProgress ? STATUS_FILTER_TITLES[paginationDelegate.filters.subProgress] : 'All'
      }
      filtersList={[
        { value: null, label: 'All' },
        {
          value: SubscriberProgress.NOT_YET_STARTED,
          label: STATUS_FILTER_TITLES[SubscriberProgress.NOT_YET_STARTED],
        },
        {
          value: SubscriberProgress.IN_PROGRESS,
          label: STATUS_FILTER_TITLES[SubscriberProgress.IN_PROGRESS],
        },
        {
          value: SubscriberProgress.COMPLETED,
          label: STATUS_FILTER_TITLES[SubscriberProgress.COMPLETED],
        },
      ]}
      applyFilter={(value: string | null) => {
        paginationDelegate.setFilterValue('subProgress', value as SubscriberIMQProgress);
      }}
    />
  );
});
